import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ImageModule } from "../image/image.module";
import { CosmosSelectComponent } from "./select.component";

@NgModule({
  declarations: [CosmosSelectComponent],
  imports: [OverlayModule, ImageModule, CommonModule],
  exports: [CosmosSelectComponent],
})
export class SelectModule { }
